import React from "react";
import { BrowserTableConfig } from "../config";
import { BrowserTableContainer, TableRow, TableCell } from "./styles";
import { useHistory } from "react-router-dom";
import { Notes } from "../BrowserOptions/styles";
import {
  SubscribeHeading,
  SubscriberSection,
  SubscribeText,
  SubscribeTexts,
} from "../../../Home/Footer/styles";
import getString from "../../../../../config/strings";
import Subscriber from "../../../../common/Subscriber";
import ReactGA from "react-ga";

function BrowserTable({
  rows,
  sentimentPositiveRatio,
  mentionsChangePositiveRatio,
}) {
  let history = useHistory();
  return (
    <BrowserTableContainer>
      {rows.map((row) => {
        return (
          <TableRow
            onClick={() => {
              ReactGA.pageview("/app/dashboard");
              ReactGA.event({
                category: "App - Browser",
                action: "Selected Stock ",
                label:row.ticker,
              });
              if (row.ticker[row.ticker.length - 1] === "*") {
                history.push(
                  "/app/dashboard?ticker=" +
                    row.ticker.slice(0, row.ticker.length - 1)
                );
              } else {
                history.push("/app/dashboard?ticker=" + row.ticker);
              }
            }}
          >
            {BrowserTableConfig.map((column) => {
              return (
                <TableCell width={column.width}>
                  <column.component
                    row={row}
                    sentimentPositiveRatio={sentimentPositiveRatio}
                    mentionsChangePositiveRatio={mentionsChangePositiveRatio}
                  />
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}

      <Notes>
        * - Growth rate has been capped at 500% as mentions are low in number
        <br />
        N/A - not enough data to calculate growth rate / Sentiment
      </Notes>
      <br />
      <br />
      <SubscriberSection>
        <SubscribeTexts>
          <SubscribeHeading>
            {getString("Home_GetAccessToday")}
          </SubscribeHeading>
          <SubscribeText>{getString("Home_GetAccessSubText")}</SubscribeText>
        </SubscribeTexts>
        <Subscriber />
      </SubscriberSection>
    </BrowserTableContainer>
  );
}
export default BrowserTable;
